export default __webpack_public_path__ + "static/media/nopainsmile.e0197146.svg";